import { Injectable } from '@angular/core';

import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class ShippingPaymentRouteReferenceService extends BaseReferenceService {
  constructor() {
    super('ShippingPaymentRouteReference');
  }
}
